export const EDIT_DEPENDENT_QUERY_KEY = ['edit', 'dependents'] as const;
